function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Card from "semantic-ui-react/dist/es/views/Card/Card.js";
import { debounce } from 'debounce';
import { GoogleMapReact } from "../../../utils/google-map-react";
import { getParentNodeWidth } from "./utils/getParentNodeWidth";
import { getHeight } from "./utils/getHeight";
import { getMaxWidth } from "./utils/getMaxWidth";
import { getImgSrc } from "./utils/getImgSrc";
import { GOOGLE_MAPS_API_KEY } from "./constants";
export var Component = function (_PureComponent) {
  _inherits(Component, _PureComponent);

  var _super = _createSuper(Component);

  function Component() {
    var _this;

    _classCallCheck(this, Component);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      isDynamicMapShowing: false,
      isMouseOverMap: false,
      parentNodeWidth: 0
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      if (!_this.img) return;
      global.addEventListener('resize', _this.setParentNodeWidth);

      _this.img.addEventListener('mousedown', _this.setIsDynamicMapShowingTrue);

      _this.img.addEventListener('mouseover', _this.setIsMouseOverMapTrue);

      _this.img.addEventListener('mouseout', _this.setIsMouseOverMapFalse);

      _this.setParentNodeWidth();
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function (previousProps, previousState) {
      return !_this.state.isDynamicMapShowing && !previousState.isMouseOverMap && _this.state.isMouseOverMap && global.setTimeout(function () {
        return _this.state.isMouseOverMap && _this.setIsDynamicMapShowingTrue();
      }, 500);
    });

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      if (!_this.img) return;
      global.removeEventListener('resize', _this.setParentNodeWidth);

      _this.img.removeEventListener('mousedown', _this.setIsDynamicMapShowingTrue);

      _this.img.removeEventListener('mouseover', _this.setIsMouseOverMapTrue);

      _this.img.removeEventListener('mouseout', _this.setIsMouseOverMapFalse);
    });

    _defineProperty(_assertThisInitialized(_this), "createRef", function (img) {
      return _this.img = img;
    });

    _defineProperty(_assertThisInitialized(_this), "setParentNodeWidth", debounce(function () {
      var parentNodeWidth = getParentNodeWidth(_this.img);

      _this.setState({
        parentNodeWidth: parentNodeWidth
      });
    }, 10));

    _defineProperty(_assertThisInitialized(_this), "setIsDynamicMapShowingTrue", function () {
      return _this.setState({
        isDynamicMapShowing: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "setIsMouseOverMapTrue", function () {
      return _this.setIsMouseOverMap(true);
    });

    _defineProperty(_assertThisInitialized(_this), "setIsMouseOverMapFalse", function () {
      return _this.setIsMouseOverMap(false);
    });

    _defineProperty(_assertThisInitialized(_this), "setIsMouseOverMap", function (isMouseOverMap) {
      return _this.setState({
        isMouseOverMap: isMouseOverMap
      });
    });

    _defineProperty(_assertThisInitialized(_this), "render", function () {
      var _this$props = _this.props,
          apiKey = _this$props.apiKey,
          bounds = _this$props.bounds,
          isFullBleed = _this$props.isFullBleed,
          isFluid = _this$props.isFluid,
          isShowingExactLocation = _this$props.isShowingExactLocation,
          isShowingApproximateLocation = _this$props.isShowingApproximateLocation,
          latitude = _this$props.latitude,
          longitude = _this$props.longitude,
          markers = _this$props.markers,
          onGoogleMapsLoad = _this$props.onGoogleMapsLoad,
          onBoundsChange = _this$props.onBoundsChange;
      var height = getHeight(_this.props.height, isFullBleed, isFluid);
      return isFullBleed ? React.createElement(GoogleMapReact, {
        apiKey: apiKey,
        bounds: bounds,
        isShowingApproximateLocation: isShowingApproximateLocation,
        isShowingExactLocation: isShowingExactLocation,
        latitude: latitude,
        longitude: longitude,
        markers: markers,
        onApiLoad: onGoogleMapsLoad,
        onBoundsChange: onBoundsChange
      }) : React.createElement(Card, {
        fluid: true,
        style: {
          height: height,
          maxWidth: getMaxWidth(isFluid)
        }
      }, isFluid || _this.state.isDynamicMapShowing ? React.createElement(GoogleMapReact, {
        apiKey: apiKey,
        bounds: bounds,
        isShowingApproximateLocation: isShowingApproximateLocation,
        isShowingExactLocation: isShowingExactLocation,
        latitude: latitude,
        longitude: longitude,
        markers: markers,
        onApiLoad: onGoogleMapsLoad,
        onBoundsChange: onBoundsChange
      }) : React.createElement("img", {
        ref: _this.createRef,
        src: getImgSrc(_this.props, height, _this.state.parentNodeWidth)
      }));
    });

    return _this;
  }

  return Component;
}(PureComponent);
Component.displayName = 'GoogleMap';
Component.defaultProps = {
  apiKey: GOOGLE_MAPS_API_KEY,
  bounds: null,
  height: '400px',
  isFluid: false,
  isFullBleed: false,
  isShowingExactLocation: false,
  isShowingApproximateLocation: false,
  latitude: null,
  longitude: null,
  markers: [],
  onGoogleMapsLoad: null,
  onBoundsChange: Function.prototype
};
Component.propTypes = process.env.NODE_ENV !== "production" ? {
  apiKey: PropTypes.string,
  bounds: PropTypes.shape({
    east: PropTypes.number.isRequired,
    north: PropTypes.number.isRequired,
    south: PropTypes.number.isRequired,
    west: PropTypes.number.isRequired
  }),
  height: PropTypes.string,
  isFluid: PropTypes.bool,
  isFullBleed: PropTypes.bool,
  isShowingApproximateLocation: PropTypes.bool,
  isShowingExactLocation: PropTypes.bool,
  latitude: PropTypes.number,
  longitude: PropTypes.number,
  markers: PropTypes.arrayOf(PropTypes.shape({
    component: PropTypes.node.isRequired,
    key: PropTypes.string.isRequired,
    latitude: PropTypes.number,
    longitude: PropTypes.number
  })),
  onBoundsChange: PropTypes.func,
  onGoogleMapsLoad: PropTypes.func
} : {};